import React, { Component } from 'react';
import './App.css';
import MailChimp from './components/mailchimp/mailchimp';
import {Instagram} from 'react-share-icons';
import {Twitter} from 'react-share-icons';

class App extends Component {
  render() {
    return (
      <div className="App">
        <div className="App-header">
          <h2>Jess Teaches You Yoga</h2>
        </div>
        <div className="App-content">
          <div className="App-intro">
              Providing nerdy, honest, and (sometimes) hilarious insights to the practice of yoga.
          </div>
          <div className="App-text">
            <img src="./img_1.jpg" alt="Me adjusting Grace" />
          </div>
          <div className="App-text">
            Jess is a recent graduate of the Sky Ting 200-Hour Teacher Training program.
          </div>
          <div className="App-text">
            <hr/>
          </div>
        </div>
        <div className="App-footer">
          <h2>Want to be kept in the loop?</h2>
          <MailChimp />
          <a href="https://www.instagram.com/jessmchung">
            <Instagram className="shares-icon"/>
          </a>
          <a href="https://www.twitter.com/jessmchung">
            <Twitter className="shares-icon"/>
          </a>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js